import type { Cart } from "@graphql/generated/types";

export const trackEvent = (paymentMethod: string, cart?: Cart) => {
    type VWOQueue = Array<unknown> & {
        event?: (eventName: string, payload: Record<string, unknown>) => void;
    };
    const vwoWindow = window as Window & { VWO?: VWOQueue };

    vwoWindow.VWO = vwoWindow.VWO || [];
    vwoWindow.VWO.event =
        vwoWindow.VWO.event ||
        function (...args: unknown[]) {
            vwoWindow.VWO?.push(["event", ...args]);
        };

    vwoWindow.VWO.event("payment", {
        currency: cart?.totalPrice?.currencyCode,
        total: cart?.totalPrice?.centAmount,
        customerId: cart?.customerId || "",
        productIDs: cart?.lineItems?.map((item) => item.productId).join(",") || "",
        shippingMethod: cart?.shippingInfo?.shippingMethod?.name || "",
        paymentMethod: paymentMethod,
    });
};
